import React from "react";
import { Row, TimePicker, Form, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";


const format = 'HH:mm';
const requiredRule = [
  {
    required: true,
    message: "Please select a time!"
  }
]
class FormTimeElement extends React.Component {

  constructor() {
    super();
    this.state={

    }
  }

  getTimeElement = () => {
    if (this.props.field) {
      return (
        <div style={{width: "100%"}}>
          <span style={{marginRight: "5px"}}>{this.props.field.name}</span>
          {this.props.field.tooltip ?
            <span><Tooltip title={this.props.field.tooltip}><InfoCircleFilled style={{color: "#0789ed"}}/></Tooltip></span>
            :null
          }
          <Form.Item
            name={[`${this.props.field.type}`, `${this.props.field.type}_${this.props.field.id}`]}
            rules={this.props.field.required || this.props.field.chosen_required ? requiredRule : null}
          >
            <TimePicker
              style={{width: "50%"}}
             format={format} />
          </Form.Item>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div>
          <Row>
            {this.getTimeElement()}
          </Row>
        </div>
      </div>
    )
  }


}


export default FormTimeElement;